<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="titleEdit" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="职称名称" prop="SysTitles.titlesName">
            <el-input class="input-item" v-model="formData.SysTitles.titlesName"
              :clearable="true" placeholder="职称名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="职称编码" prop="SysTitles.titlesCode">
            <el-input class="input-item" v-model="formData.SysTitles.titlesCode"
              :clearable="true" placeholder="职称编码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="显示顺序" prop="SysTitles.showOrder">
            <el-input class="input-item" v-model="formData.SysTitles.showOrder"
              :clearable="true" placeholder="显示顺序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('titleEdit:titleEdit:add')"
              @click="onAddClick()">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              关闭
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysTitlesController, DictionaryController } from '@/api';

export default {
  name: 'titleEdit',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SysTitles: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          titlesName: undefined,
          titlesCode: undefined,
          showOrder: undefined,
          isDatasourceInit: false
        }
      },
      titleEdit: {
        formFilter: {
        },
        formFilterCopy: {
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 更新职称编辑
     */
    refreshTitleEdit (reloadData = false) {
      this.loadSysTitlesData().then(res => {
        if (!this.titleEdit.isInit) {
          // 初始化下拉数据
        }
        this.titleEdit.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onAddClick () {
      this.$refs.titleEdit.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            ...this.formData.SysTitles
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          sysTitlesDto: {
            id: this.id,
            showOrder: this.formData.SysTitles.showOrder,
            orgCode: this.formData.SysTitles.orgCode,
            titlesName: this.formData.SysTitles.titlesName,
            titlesCode: this.formData.SysTitles.titlesCode
          }
        };

        if (this.id == null) {
          SysTitlesController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          SysTitlesController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    /**
     * 获取系统职称表详细信息
     */
    loadSysTitlesData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SysTitles.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SysTitlesController.view(this, params).then(res => {
            this.formData.SysTitles = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.SysTitles.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysTitles: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          titlesName: undefined,
          titlesCode: undefined,
          showOrder: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshTitleEdit();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SysTitles = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
